import { render, staticRenderFns } from "./AdmissionLetter.vue?vue&type=template&id=e0481af0&scoped=true"
import script from "./AdmissionLetter.vue?vue&type=script&lang=js"
export * from "./AdmissionLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0481af0",
  null
  
)

export default component.exports